import {
  useState,
  useEffect,
  JSXElementConstructor,
  Key,
  ReactElement,
  ReactFragment,
  ReactPortal,
} from "react";
import { connect } from "react-redux";
import { Link, useLocation, useParams } from "react-router-dom";
import Modal from "react-bootstrap/Modal";
import { InAppTemplate } from "../../../shared/templates/inapp";

import { TableComponent } from "../../../shared/components/table";

import { Formik, Form, Field, FormikProps, ErrorMessage } from "formik";
import * as Yup from "yup";

// import { getDateFromISO, formatPhoneNumber } from "../../../shared/utils";

import { AlertMsg } from "../../../shared/components/alert-msg";

import { LoadingItem } from "../../../shared/components/loading";
// import DownloadIco from "../../../assets/download.svg";
import BackIco from "../../../assets/back.svg";
import SuspendIco from "../../../assets/icons/suspend.svg";
// import ShopIco from "../../../assets/shop_ico.svg";

import { appActions } from "../../../redux/actions/in-app";
import { appConstants } from "../../../redux/action-constants/inapp.constants";

import { history } from "../../../shared/_helpers/history";
// import { Editor } from "react-draft-wysiwyg";
import { NavLink } from "react-router-dom";

// import TrendUp from "../../../assets/trend_up.svg";
// import { useWindowSize } from "../../../hooks/useWindowSize";

import "../store.scss";

const getStoreDetails = async ({ pageProps, payload }: any) => {
  await pageProps.getStoreDetailsAction(payload);
};
const updateStore = async ({ pageProps, payload }: any) => {
  await pageProps.updateStoreAction(payload);
};

const InAppContent = ({ pageProps }: any) => {
  const { storeId } = useParams();

  //   useEffect(() => {
  //     setActive(
  //       pageProps.getStoreDetailsRequest?.request_data?.response?.data
  //         ?.isActive ?? false
  //     );
  //   }, [pageProps]);

  useEffect(() => {
    getStoreDetails({
      pageProps,
      payload: `?Id=${storeId}`,
    });
  }, []);

  const EditDisplay = () => {
    let storeDetails =
      pageProps.getStoreDetailsRequest?.request_data?.response?.data;
    // const [showSuspendModal, setShowSuspendModal] = useState<boolean>(false);

    return (
      <div className="reports_wrap">
        <div className="report_head_wrap">
          <div
            className="report_head_left"
            onClick={() => history.push(`/app/stores/${storeId}/details`)}
          >
            <div className="report_heading">
              <img className="back_ico" src={BackIco} alt="" />{" "}
              <span className="main_head_txt">Edit store information</span>{" "}
            </div>
          </div>
        </div>

        <div className="store_edit_section">
          {/* {pageProps.getStoreDetailsRequest.request_status ===
            appConstants.GET_STORE_DETAILS_PENDING && <LoadingItem />}
          {pageProps.getStoreDetailsRequest.request_status ===
            appConstants.GET_STORE_DETAILS_SUCCESS && <></>}
          {pageProps.getStoreDetailsRequest.request_status ===
            appConstants.GET_STORE_DETAILS_FAILURE && (
            <div className="all_graphs">
              <AlertMsg
                type="error"
                message={pageProps.getStoreDetailsRequest?.request_data.error}
              />
            </div>
          )} */}

          <div className="store-menus">
            <NavLink
              end
              className={({ isActive }) => (isActive ? "active-nav" : "")}
              to={`/app/stores/${storeId}/edit`}
            >
              Store Details
            </NavLink>

            <NavLink
              end
              className={({ isActive }) => (isActive ? "active-nav" : "")}
              to={`/app/stores/${storeId}/edit/staff`}
            >
              Staff Account
            </NavLink>
            <NavLink
              end
              className={({ isActive }) => (isActive ? "active-nav" : "")}
              to={`/app/stores/${storeId}/edit/withdrawal`}
            >
              Withdrawal Method
            </NavLink>
          </div>
          <h1>Withdrawal</h1>
        </div>
      </div>
    );
  };

  // console.log("getDashbardBottompDataRequest", getDashbardBottompDataRequest);
  return (
    <div className="inapp-content">
      <div className="page-content dashboard">
        {pageProps.getStoreDetailsRequest.request_status ===
          appConstants.GET_STORE_DETAILS_PENDING && <LoadingItem />}
        {pageProps.getStoreDetailsRequest.request_status ===
          appConstants.GET_STORE_DETAILS_SUCCESS && <EditDisplay />}
        {pageProps.getStoreDetailsRequest.request_status ===
          appConstants.GET_STORE_DETAILS_FAILURE && (
          <AlertMsg
            type="error"
            message={pageProps.getStoreDetailsRequest?.request_data.error}
          />
        )}
      </div>
    </div>
  );
};

const StoreWithdrawalManagement = (pageProps: any) => {
  return (
    <InAppTemplate
      pageHeadingTitle="Withdrawal Management"
      childComponent={<InAppContent pageProps={pageProps} />}
    />
  );
};

const mapDispatchToProps = {
  getStoreDetailsAction: appActions.GetStoreDetails,
  updateStoreAction: appActions.UpdateStore,
};

const mapStateToProps = (state: any) => ({
  getStoreDetailsRequest: state.allInAppReducers.getStoreDetailsReducer,
  updateStoreRequest: state.allInAppReducers.updateStoreReducer,
});
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(StoreWithdrawalManagement);
